import { jsxs, jsx } from "react/jsx-runtime";
const IconPersonSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M16.003 3.875a1.876 1.876 0 1 1-3.75 0 1.876 1.876 0 0 1 3.75 0Zm-5.058 5.91-.114.047-.312.137a2.507 2.507 0 0 0-1.356 1.492l-.101.305a1.248 1.248 0 0 1-1.582.79 1.248 1.248 0 0 1-.79-1.583l.102-.305A5.01 5.01 0 0 1 9.503 7.68l.313-.137a6.383 6.383 0 0 1 2.582-.547 4.31 4.31 0 0 1 3.98 2.653l.602 1.441.836.418a1.249 1.249 0 1 1-1.117 2.235l-1.047-.52a1.867 1.867 0 0 1-.89-.957l-.376-.898-.754 2.558 1.934 2.11c.21.23.36.508.437.812l.899 3.598a1.25 1.25 0 1 1-2.426.606l-.86-3.442-2.761-3.012a2.498 2.498 0 0 1-.575-2.332l.66-2.48h.005Zm-2.258 7.763.976-2.438c.082.117.176.227.274.336l1.59 1.734-.567 1.415a1.88 1.88 0 0 1-.414.629l-2.41 2.41a1.252 1.252 0 0 1-1.77-1.77l2.32-2.316Z" })
    ]
  }
);
export {
  IconPersonSvg
};
